import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ComponentBase } from '../../../_infrastructure/classes/componentBase';
import { HttpParams } from '@angular/common/http';
import { UntypedFormBuilder } from '@angular/forms';
import { Table } from 'primeng/table';
import { TwTcEppoViewModel, TwTcEppoItemResultsViewModel } from '../../../_infrastructure/types/common';
import { GlobalService } from '../../../_infrastructure/classes/services/global.service';
import { Dialog } from 'primeng/dialog';

@Component({
    selector: 'app-codigo-eppo-popup',
    templateUrl: './codigoEppoPopup.component.html',
})
export class CodigoEppoPopupComponent extends ComponentBase implements OnInit {
    @Output() selected = new EventEmitter<TwTcEppoViewModel>();

    @ViewChild('tableSearch') turboTable: Table;

    resultCodigoEppo: TwTcEppoItemResultsViewModel;
    display = false;
    cols: any[];
    IdCodigoEppo: number;
    selectedCodigoEppo: TwTcEppoViewModel | null;
    isCollapsed = false;

    constructor(private fb: UntypedFormBuilder, private globalService: GlobalService) {
        super();
    }

    ngOnInit() {
        this.cols = [
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'CodigoEppo', header: 'Código Eppo' },
        ];

        this.form = this.fb.group({
            CodigoEppo: '',
        });
    }

    onSearchButton(): void {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        this.searchingButton = true;
        this.isCollapsed = true;
    }

    Search(pageNumber: number, asc = 0, orderBy = ''): void {
        let params = new HttpParams();

        params = params.append('pageNumber', pageNumber.toString());
        params = params.append('asc', asc.toString());
        params = params.append('orderBy', orderBy);
        params = params.append('codigoeppo', this.form.value.CodigoEppo);
        params = params.append('IsPopup', 'true');

        this.loading = true;

        //valdrían las dos llamadas, pero se ha quitado del codigoepposervice y se ha dejado en globalService
        //this.codigoeppoService.getCodigoEppoPagedByFilter(params).subscribe(
        this.globalService.getCodigoEppoPagedByFilter(params).subscribe(result => {
            if (result) {
                this.selectedCodigoEppo = null;
                this.resultCodigoEppo = result;
                this.loading = false;
            }
        });
    }

    onSearchLazy(event: any): void {
        if (!event.rows) {
            return;
        }

        let pageNumber = event.first / event.rows;

        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton(): void {
        this.form.setValue({
            CodigoEppo: '',
        });

        this.isCollapsed = false;
    }

    showDialog(id: number | null): void {
        this.display = true;
        this.selectedCodigoEppo = null;
    }

    onRowDblClick(event: any, codigoEppo: TwTcEppoViewModel): void {
        this.display = false;
        this.selected.emit(codigoEppo);
    }

    acceptDialog(): void {
        this.display = false;
        this.selected.emit(this.selectedCodigoEppo!);
    }

    cancelDialog(): void {
        this.display = false;
    }

    showDialogMaximized(dialog: Dialog): void {
        setTimeout(() => {
            dialog.maximize();
        }, 0);
    }

    onSelect(selection: TwTcEppoViewModel): void {
        this.selectedCodigoEppo = selection;
    }

    noAccepted(): boolean {
        return !this.form.valid || !this.selectedCodigoEppo;
    }
}
